<template>
  <div>
    <div class="block_5 flex-col">
          <span class="paragraph_1">
            &ensp;&ensp;&ensp;&ensp;高校后勤的管理品质决定着高校校园的教学品质、安全品质、环境品质、资产品质和服务品质，也是高校教学科研的基本保障、是高校形象的直接展示。
            <br />
            &ensp;&ensp;&ensp;&ensp;公司市场布局重庆、江苏、河南、河北、江西、湖南、广东等全国10个省、直辖市、自治区，服务项目近12余个，在管项目面积50000余平方米。
          </span>
      <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="../assets/img/img7.webp"
      />
    </div>
    <div class="block_6 flex-col">
          <span class="paragraph_2">
            &ensp;&ensp;&ensp;&ensp;公司始终以高品质的服务为出发点，先后设立保安、保洁、设施设备管理等专业职能部门，以市场化的方式为客户的后勤保障需求提供全面解决方案，跟踪解决服务项目，不断拓展物业服务的广度和深度。
            <br />
            &ensp;&ensp;&ensp;&ensp;目前，在各级部门的领导下，公司努力实现“全国TOP级校园全维度服务管家”的愿景，成为最受客户及合作伙伴信赖的校园服务运营机构。
          </span>
      <img
          class="image_3"
          referrerpolicy="no-referrer"
          src="../assets/img/img8.webp"
      />
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        constants: {}
      };
    },
    methods: {}
  };
</script>
<style scoped lang="css" src="../assets/index.css" />
